import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=0d7c5444&scoped=true"
import script from "@/views/Requests/Request.ts?vue&type=script&lang=ts&external"
export * from "@/views/Requests/Request.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Requests/request.scss?vue&type=style&index=0&id=0d7c5444&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c5444",
  null
  
)

export default component.exports